import { createSlice } from '@reduxjs/toolkit';

const initialTemplateState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    templateForEdit: undefined,
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const templateSlice = createSlice({
    name: 'template-notification',
    initialState: initialTemplateState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
                state.actionsLoading = false;
            } else {
                state.listLoading = false;
                state.actionsLoading = true;
            }
        },

        // getTemplateById
        templateFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.templateForEdit = action.payload.templateForEdit;
        },
        // findTemplate
        templatesFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },
        // Set to default state actionLoading & error
        templateReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

